module.exports = __webpack_public_path__ + "assets/humidity.5b82020c.svg";